import { ref } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { PREPARE_MODULE_REGISTRATION_PAYMENTS } from '@/graphql/mutations/modulePayments';
import { evictBillingQueries } from '@/utils/billingCache';
import { toUserMessage } from '@/utils/error';
import type { PrepareModuleRegistrationPaymentsMutation, PrepareModuleRegistrationPaymentsMutationVariables } from '@/types/operations';

export function usePrepareModulePayments() {
  const error = ref('');
  const { mutate, loading } = useMutation<PrepareModuleRegistrationPaymentsMutation, PrepareModuleRegistrationPaymentsMutationVariables>(PREPARE_MODULE_REGISTRATION_PAYMENTS, {
    update: evictBillingQueries,
  });
  async function prepare(moduleIds: string[], initiateRetake = false) {
    error.value = '';
    try {
      return (await mutate({ module_ids: moduleIds, initiate_retake: initiateRetake }))?.data?.prepareModuleRegistrationPayments ?? null;
    } catch (failure) {
      error.value = toUserMessage(failure, 'We couldn\'t create the bill for these modules. Please try again.');
      return null;
    }
  }
  return { prepare, loading, error };
}
